
/*
* komponen ini menggunakan material tailwind, jika ingin mengubah atau menambah
* lihat halaman ini sebagai referensi
* https://www.material-tailwind.com/docs/react/installation
*
*/

import { RootContext } from '../../../App';
import axiosInstance from '../../../config/axios';
import refactorStructureData from '../../../helpers/refactorDataMenu';
import Card from "@material-tailwind/react/Card";
import CardHeader from "@material-tailwind/react/CardHeader";
import CardBody from "@material-tailwind/react/CardBody";
import Input from "@material-tailwind/react/Input";
import Button from "@material-tailwind/react/Button";
import React, { useContext, useState } from "react";
import { useEffect } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ReactLoading from "react-loading";
import Swal from "sweetalert2";
import Image from "@material-tailwind/react/Image";
import { Textarea } from '@material-tailwind/react';

export default function SiteConfig() {

    const [listData, setListData] = useState();
    const [newData, setNewData] = useState([]);
    const { state, setState } = useContext(RootContext);
    const history = useHistory();
    const [saving, setSaving] = useState();
    const group = JSON.parse(localStorage.getItem("group"));

    const [webName, setWebName] = useState();
    const [contact, setContact] = useState();
    const [webLivechat, setWebLivechat] = useState();
    const [webLivechatLink, setWebLivechatLink] = useState();
    const [globalMetaTag, setGlobalMetaTag] = useState();
    const [webRunningText, setWebRunningText] = useState();
    const [googleConsoleCode, setGoogleConsoleCode] = useState();
    const [linkFacebook, setLinkFacebook] = useState();
    const [linkTelegram, setLinkTelegram] = useState();
    const [linkWhatsapp, setLinkWhatsapp] = useState();
    const [ampLogin, setAmpLogin] = useState();
    const [ampRegister, setAmpRegister] = useState();
    const [linkAlternative, setLinkALternative] = useState();

    const handleChangeImage = () => {

        history.push('/web_management/cms/update_web_logo');
    }

    const handleSave = () => {

        const token = localStorage.getItem("access_token");

        if (!token) {

            /* history.push("/login");
            console.log('Not Valid Token'); */

        } else {

            try {

                const data = {
                    token : token,
                    group : group.wbid,

                    webname           : webName,
                    contact           : contact,
                    weblivechat       : webLivechat,
                    weblivechatlink   : webLivechatLink,
                    globalmetatag     : globalMetaTag,
                    webrunningtext    : webRunningText,
                    googleconsolecode : googleConsoleCode,
                    linkFacebook      : linkFacebook,
                    linkTelegram      : linkTelegram,
                    linkWhatsapp      : linkWhatsapp,
                }

                axiosInstance('update_site_config_v2', {

                    method: "POST",

                    data: data,

                }).then((res) => {

                    localStorage.setItem("access_token", res.data.data.token);

                    if(res.data.code === 0) {

                        Swal.fire(
                            'Saved',
                            'Data Saved',
                            'success',
                        );

                        setSaving(false);
                    }else{

                        Swal.fire(
                            'Failed',
                            'Failed To save',
                            'error',
                        );

                        setSaving(false);
                        console.log('Error Mesage: '+res.data.message);
                    }

                }).catch((err) => {

                    let errstatus = err.response.status;
    
                    let errmesage = err.response.data.message;
        
                    if(errstatus === 401){
        
                        Swal.fire(
                            'Expire Token',
                            'Your Token Has Expire',
                            'warning'
                        ).then(() => {
        
                            console.log("Token Expire 401");
                            localStorage.removeItem("access_token");
        
                            history.push("/login");
                        });
        
                    }else{
        
                        Swal.fire(
                            'Warning',
                            errmesage,
                            'warning'
                        ).then(() => {
        
                            setSaving(false);
        
                        })
                    }

                });

            } catch (error) {

                Swal.fire(
                    'Warning',
                    error,
                    'warning'
                ).then(() => {

                    setSaving(false);

                })

            }

        }
    }

    const getData = () => {

        const token = localStorage.getItem("access_token");

        const data = {

            token: token,
            group: group.wbid,
        }

        if (!token) {

            history.push("/login");
            console.log('Not Valid Token');

        } else {

            try {

                axiosInstance('get_site_config', {

                    method: "POST",

                    data,

                }).then((res) => {

                    const data = res.data.data.list;

                    localStorage.setItem("access_token", res.data.data.token);

                    setListData(data);

                    setNewData({...newData, token: res.data.data.token, group: group.wbid})

                    setState({

                        ...state,

                        group: res.data.data.additional_data.group,

                        menu: refactorStructureData(res.data.data.additional_data.menu),

                    });

                }).catch((err) => {

                    let errstatus = err.response.status;
    
                    let errmesage = err.response.data.message;
        
                    if(errstatus === 401){
        
                        Swal.fire(
                            'Expire Token',
                            'Your Token Has Expire',
                            'warning'
                        ).then(() => {
        
                            localStorage.removeItem("access_token");
        
                            history.push("/login");

                            console.log("2Token Expire 401");
                        });
        
                    }else{
        
                        Swal.fire(
                            'Warning',
                            errmesage,
                            'warning'
                        ).then(() => {
        
                            setSaving(false);
        
                        })
                    }

                });

            } catch (error) {

                Swal.fire(
                    'Warning',
                    error,
                    'warning'
                ).then(() => {

                    setSaving(false);

                })

            }

        }

    };

    useEffect(() => {

        getData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div className="bg-gradient-to-br from-purple-500 to-blue-500 pt-14 pb-28 px-3 md:px-8 h-auto"></div>
            
            <div className="px-3 md:px-8 -mt-24">
                {!listData ? (
                    <div className="flex justify-center items-center" style={{ minHeight: '400px' }}>
                        <ReactLoading
                            type="spinningBubbles"
                            color="rgb(147, 51, 234)"
                            height={100}
                            width={100}
                        />
                    </div>
                ) : (
                    <div className="container mx-auto max-w-full">
                        <Card>
                            <CardHeader color="blueGray" contentPosition="left">
                                <h2 className="text-white text-2xl">Site Configuration</h2>
                            </CardHeader>

                            <CardBody>
                                {/* Logo Section - Full Width */}
                                <div className="mb-8 pb-8 border-b border-gray-200">
                                    <h6 className="text-purple-600 text-lg font-semibold mb-4 uppercase tracking-wide">
                                        <i className="fas fa-image mr-2"></i>
                                        Website Logo
                                    </h6>
                                    <div className="flex justify-center items-center">
                                        <div className="relative group">
                                            <div className="h-48 w-48 rounded-xl shadow-lg overflow-hidden border-4 border-purple-100 transition-all duration-300 group-hover:border-purple-400 cursor-pointer">
                                                <Image
                                                    src={listData['weblogo']}
                                                    alt="logo image" 
                                                    onClick={handleChangeImage}
                                                    className="object-contain w-full h-full"
                                                />
                                            </div>
                                            <p className="text-center mt-3 text-sm text-gray-600 group-hover:text-purple-600 transition-colors">
                                                <i className="fas fa-hand-pointer mr-1"></i>
                                                Click image to change
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                {/* Two Column Layout */}
                                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                                    {/* Left Column */}
                                    <div className="space-y-8">
                                        {/* Web Name */}
                                        <div className="mt-3 mb-3">
                                            <h6 className="text-purple-600 text-sm font-semibold uppercase tracking-wide flex items-center">
                                                <i className="fas fa-globe mr-2"></i>
                                                Web Name
                                            </h6>
                                            <Input
                                                type="text"
                                                color="purple"
                                                placeholder=" "
                                                defaultValue={listData['webname']}
                                                onChange={(e) => setWebName(e.target.value)}
                                            />
                                        </div>

                                        {/* Contact */}
                                        <div className="mt-3 mb-3">
                                            <h6 className="text-purple-600 text-sm font-semibold uppercase tracking-wide flex items-center">
                                                <i className="fas fa-phone mr-2"></i>
                                                Contact
                                            </h6>
                                            <Input
                                                type="text"
                                                color="purple"
                                                placeholder=" "
                                                defaultValue={listData['contact']}
                                                onChange={(e) => setContact(e.target.value)}
                                            />
                                        </div>

                                        {/* Web Livechat */}
                                        <div className="mt-3 mb-3">
                                            <h6 className="text-purple-600 text-sm font-semibold uppercase tracking-wide flex items-center">
                                                <i className="fas fa-comments mr-2"></i> Web Livechat
                                            </h6>
                                            <Input
                                                type="text"
                                                color="purple"
                                                placeholder=" "
                                                defaultValue={listData['weblivechat']}
                                                onChange={(e) => setWebLivechat(e.target.value)}
                                            />
                                        </div>

                                        {/* Web Running Text */}
                                        <div className="mt-3 mb-3">
                                            <h6 className="text-purple-600 text-sm font-semibold uppercase tracking-wide flex items-center">
                                                <i className="fas fa-scroll mr-2"></i>
                                                Web Running Text
                                            </h6>
                                            <Input 
                                                color="purple" 
                                                placeholder=" "
                                                defaultValue={listData['webruningtext']}
                                                onChange={(e) => setWebRunningText(e.target.value)}
                                            />
                                        </div>

                                        {/* Global Meta Tag */}
                                        <div>
                                            <h6 className="text-purple-600 text-sm font-semibold uppercase tracking-wide flex items-center">
                                                <i className="fas fa-code mr-2"></i>
                                                Global Meta Tag
                                            </h6>
                                            <Textarea 
                                                color="purple" 
                                                placeholder=" "
                                                defaultValue={listData['globalmetatag']}
                                                onChange={(e) => {
                                                    setGlobalMetaTag(btoa(e.target.value));
                                                }}
                                                rows={4}
                                            />
                                        </div>
                                    </div>

                                    {/* Right Column */}
                                    <div className="space-y-8">
                                        {/* Link Facebook */}
                                        <div className="mt-3 mb-3">
                                            <h6 className="text-purple-600 text-sm font-semibold uppercase tracking-wide flex items-center">
                                                Link Facebook
                                            </h6>
                                            <Input 
                                                color="purple" 
                                                placeholder=" "
                                                defaultValue={listData['link_fb']}
                                                onChange={(e) => {
                                                    setLinkFacebook(e.target.value);
                                                }}
                                            />
                                        </div>
                                        
                                        {/* Link Telegram */}
                                        <div className="mt-3 mb-3">
                                            <h6 className="text-purple-600 text-sm font-semibold uppercase tracking-wide flex items-center">
                                                Link Telegram
                                            </h6>
                                            <Input 
                                                color="purple" 
                                                placeholder=" "
                                                defaultValue={listData['link_tele']}
                                                onChange={(e) => {
                                                    setLinkTelegram(e.target.value);
                                                }}
                                            />
                                        </div>

                                        {/* Link Whatsapp */}
                                        <div className="mt-3 mb-3">
                                            <h6 className="text-purple-600 text-sm font-semibold uppercase tracking-wide flex items-center">
                                                Link Whatsapp
                                            </h6>
                                            <Input 
                                                color="purple" 
                                                placeholder=" "
                                                defaultValue={listData['link_whatsapp']}
                                                onChange={(e) => {
                                                    setLinkWhatsapp(e.target.value);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Save Button at Bottom */}
                                <div className="mt-10 pt-6 border-t border-gray-200 flex justify-end">
                                    <Button
                                        className="h-10
                                            px-5 m-2
                                            text-green-100 
                                            transition-colors 
                                            duration-150 
                                            bg-green-700 
                                            rounded-lg 
                                            focus:shadow-outline 
                                            hover:bg-green-800"
                                        rounded={false}
                                        block={false}
                                        iconOnly={false}
                                        ripple="light"
                                        onClick={() => {
                                            setSaving(true);
                                            handleSave();
                                        }}
                                        disabled={saving}
                                    >
                                        {!saving ? (
                                            <>
                                                <i className="fas fa-save mr-2"></i>
                                                Save All Changes
                                            </>
                                        ) : (
                                            <>
                                                <i className="fas fa-spinner fa-spin mr-2"></i>
                                                Saving...
                                            </>
                                        )}
                                    </Button>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                )}
            </div>
        </>

    );

}
